import { useCallback } from 'react';
import { useHistory } from 'react-router';
import { Machine } from '../../api/graphql/generated';
import { useBeaconRouter } from '../../route/route.hooks';
import { ProgramState, SafetyState } from './machine-state';

export const isProgramStopped = (
  programState: ProgramState | string
): boolean => {
  return programState
    ? programState !== ProgramState.PROGRAM_PLAYING &&
        programState !== ProgramState.PROGRAM_PAUSED &&
        programState !== ProgramState.PROGRAM_PAUSING
    : true;
};

export const isProgramState = (
  machine: Machine,
  programStates: ProgramState[]
): boolean => {
  return (
    programStates.find(
      (programState) =>
        programState === machine?.state?.transient?.status?.programState
    ) !== undefined
  );
};

export const isSafetyState = (
  machine: Machine,
  safetyStates: SafetyState[]
): boolean => {
  return (
    safetyStates.find(
      (safetyState) =>
        safetyState === machine.state?.transient?.status?.safetyState
    ) !== undefined
  );
};

export const useNavigateToMachine = () => {
  const { builder } = useBeaconRouter();
  const { push } = useHistory();

  const callback = useCallback(
    (machine: Machine) => {
      const cloudRoute = builder.getMachineRoute(machine.teamId, machine.id);
      push(cloudRoute);
    },
    [push, builder]
  );

  return callback;
};
